import { useEffect } from 'react';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useShallow } from 'zustand/react/shallow';
import { filterSelectedDateFromSlots } from '@/utils/slotCalendarFunctions';
import { sortSlotsByStartTime } from '@/utils/scanDates';

export const useAvailableSlots = () => {
  const { currentSlot, location, currentDate, setError, slots, removeError } = usePrenuvoStore(
    useShallow((state) => ({
      currentSlot: state.scan.slot,
      location: state.scan.location,
      currentDate: state.scan.date,
      setError: state.scan.methods.setError,
      slots: state.scan.slots,
      removeError: state.scan.methods.removeError,
    })),
  );

  useEffect(() => {
    if (!currentSlot) setError('slot', 'Please select a scan date and time');
    else removeError('slot');
  }, [setError, currentSlot, removeError]);

  const selectedDateSlot = filterSelectedDateFromSlots(slots, currentDate);
  const { availableSlots } = selectedDateSlot;
  // EC-393: Sort available slots by start time
  const sortedAvailableSlots = sortSlotsByStartTime(availableSlots);

  return {
    availableSlots,
    sortedAvailableSlots,
    currentDate,
    location,
  };
};
